import React, { lazy, Suspense } from "react";
import TwoFactorAuth from "./components/TwoFactorAuth/TwoFactorAuth";
import "./Security.scss";
import "./SecurityMobile.scss";

const UpdateMaxStake = lazy(() => import("./components/UpdateMaxStake"));
const ChangePassword = lazy(() => import("./components/ChangePassword"));

type Props = {
  isLoading: boolean;
  account: any;
  showUpdateMessage: (...args: Array<any>) => any;
};

const Security: React.FC<Props> = ({ account, showUpdateMessage }) => {
  return (
    <div className="security__component">
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <ChangePassword
          showUpdateMessage={showUpdateMessage}
          account={account}
        />
      </Suspense>

      <hr className="security__divider" />
      <TwoFactorAuth
        twoFactorAuthenticationEnabled={account.twoFactorAuthenticationEnabled}
      />
      <hr className="security__divider" />
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <UpdateMaxStake account={account} />
      </Suspense>
    </div>
  );
};

export default Security;
